import { render, staticRenderFns } from "./PasoExtraPlazasParking.vue?vue&type=template&id=0b019c35"
import script from "./PasoExtraPlazasParking.vue?vue&type=script&lang=js"
export * from "./PasoExtraPlazasParking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports